import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeSettingActionAsync } from '../redux/actions/typeSettingActions'

export const useTypesSetting = () => {
  const { typeSettingState } = useSelector(
    (state: RootState) => state.typeSetting
  )
  const dispatch = useDispatch()

  const getTypesSetting = () => {
    dispatch(getTypeSettingActionAsync())
  }

  return { typeSettingState, getTypesSetting }
}
